import { useState } from "react";

/**
 * A report's filters as what's applied (the address bar, so a report is a link somebody can send) and
 * what's being edited. Nothing reloads until the screen applies the draft.
 *
 * Edits fall away when what's applied changes, whether by Apply or by a link into the same report.
 */
export function useDraftFilters<T extends Record<string, string>>(applied: T) {
  const [edits, setEdits] = useState<Partial<T>>({});
  const key = JSON.stringify(applied);
  const [seen, setSeen] = useState(key);
  if (seen !== key) {
    setSeen(key);
    setEdits({});
  }

  const draft: T = { ...applied, ...edits };
  const changed = Object.keys(applied).some(
    (name) => draft[name]?.trim() !== applied[name]?.trim(),
  );

  return {
    draft,
    /** Whether Apply has anything to do. */
    changed,
    edit: (next: Partial<T>) => setEdits((current) => ({ ...current, ...next })),
    discard: () => setEdits({}),
  };
}
